import _slicedToArray from "E:\\Agents\\Agent-04\\_work\\53\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import React from 'react';
import { get } from '../../utils';
import { Placeholder, Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import FunFactsItem, { commonStyles, rtlStyles, ltrStyles } from '../21_FunFactsItem/FunFactItem';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { useInView } from 'react-intersection-observer';
import { convertToAnalyticObject } from '../../utils/analytics';
export var FunFactsContainer = function FunFactsContainer(_ref) {
  var fields = _ref.fields,
    rendering = _ref.rendering,
    params = _ref.params;
  var _useInView = useInView({
      rootMargin: '100px 0px 100px 0px',
      triggerOnce: true
    }),
    _useInView2 = _slicedToArray(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var title = get(fields, 'data.item.title.jss');
  var titleContainer = get(title, 'value');
  var showNumber = get(fields, 'data.item.showNumber.jss') || false;
  var placeholdersItems = get(rendering, 'placeholders.funfacts-container');
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  if (!fields) {
    console.warn('FunFactsContainer component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [FunFactsContainer component is empty: please provide data source]");
    }
    return null;
  }
  var renderItems = function renderItems() {
    if (placeholdersItems) {
      return placeholdersItems.map(function (item, index) {
        return /*#__PURE__*/React.createElement(FunFactsItem, {
          key: item.uid,
          showNumber: showNumber,
          index: index,
          inView: inView,
          titleContainer: titleContainer,
          fields: _objectSpread({}, item.fields),
          params: {
            params: params
          },
          oneItem: !(placeholdersItems.length > 1)
        });
      });
    }
    return [];
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, !pageEditing ? /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref2) {
    var renderCarousel = _ref2.renderCarousel,
      renderPreviousButton = _ref2.renderPreviousButton,
      renderNextButton = _ref2.renderNextButton,
      renderDots = _ref2.renderDots;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "facts__navigation ".concat(rtl ? 'btn-group-rtl' : '')
    }, renderPreviousButton(function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['prevNavAnalytics'], params));
    }), renderNextButton(function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['nextNavAnalytics'], params));
    })), renderCarousel(renderItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 0
          },
          items: 1
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 1
        }
      }
    }, function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['mobileSlidesAnalytics'], params));
    }), renderDots(function () {
      renderDots(function () {
        return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navBubblesAnalytics'], params));
      });
    }));
  }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    field: title
  }), /*#__PURE__*/React.createElement(Placeholder, {
    name: "funfacts-container",
    rendering: rendering
  })));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl,
    anchorUrlParameter = _ref3.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
export default FunFactsContainer;